/* RESPONSIBLE TEAM: team-ai-agent */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import { DRAWER_EDITOR_QUERY_PARAMS } from 'embercom/services/knowledge-hub-drawer-editor-service';
import type { EditorMode } from 'embercom/components/knowledge-hub/content-editor/drawer-editor';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';

export default class ConfigurationAgentController extends Controller {
  @service declare router: RouterService;
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;

  queryParams = [
    ...DRAWER_EDITOR_QUERY_PARAMS,
    'proposalChatId',
    'proposalUuid',
    'proposalEntityType',
    'proposalEntityId',
    'chatId',
  ];

  // Knowledge hub drawer editor query params
  @tracked activeContentId?: number;
  @tracked activeContentType?: string;
  @tracked editorMode?: EditorMode;
  @tracked collectionId?: string;
  @tracked contentLocale?: string;
  @tracked folderId?: string;

  // Proposal drawer query params
  @tracked proposalChatId: string | null = null;
  @tracked proposalUuid: string | null = null;
  @tracked proposalEntityType: string | null = null;
  @tracked proposalEntityId: string | null = null;

  // Chat persistence query param
  @tracked chatId: string | null = null;

  get isProposalPanelOpen(): boolean {
    return (
      this.proposalChatId !== null &&
      this.proposalUuid !== null &&
      this.proposalEntityType !== null &&
      this.proposalEntityId !== null
    );
  }

  @action
  closeProposalPanel(): void {
    // Notify React to close the main content area
    this.reactTeammateAppIsland.dispatchBridgeEvent('teammate-app:event', {
      identifier: 'internal-agent:main-content-closed',
      data: {},
    });

    this.router.transitionTo({
      queryParams: {
        proposalChatId: null,
        proposalUuid: null,
        proposalEntityType: null,
        proposalEntityId: null,
      },
    });
  }
}
